// Display copy follows each step's existing charts. The lecture curriculum and
// saved worksheet titles remain in courses.json and planning.js unchanged.
export const ReadingGuide = {
  'first-home': {
    1: { title: '가격대 찾기', description: '매매가격 범위를 선택해 해당 구간의 단지 목록을 확인합니다.' },
    2: { title: '생활권 비교', description: '같은 반경과 기간의 입주예정물량을 보고, 국민연금 가입자 현황을 함께 비교합니다.' },
    3: { title: '가격 검증', description: '가격대별 단지, 실거래가격, 시군구 지표를 같은 지역 기준으로 비교합니다.' },
    4: { title: '매물 흐름', description: '단지 세대수 대비 주간 매물수 변화와 매매·전세 가격 지표를 함께 봅니다.' },
    5: { title: '단지 비교', description: '단지·면적별 매매·전세 지표와 실거래가격을 차례로 확인합니다.' }
  },
  'move-home': {
    1: { title: '보유 단지 현황', description: '최근 실거래가격과 주간 매물지수로 보유 단지의 가격과 매물 현황을 확인합니다.' },
    2: { title: '가격 차이 비교', description: '가격대별 단지 목록을 보고, 현재 단지와 관심 단지의 매매·전세 지표를 비교합니다.' },
    3: { title: '지역 흐름', description: '시군구별 가격·거래 지표와 기간별 입주물량을 비교합니다.' },
    4: { title: '매물 흐름', description: '관심 단지의 주간 매물지수가 어떻게 변했는지 같은 기간으로 확인합니다.' },
    5: { title: '실거래 확인', description: '현재 단지와 관심 단지의 실거래가격을 면적과 거래 시점에 맞춰 비교합니다.' }
  },
  'first-investment': {
    1: { title: '매매·전세 조건', description: '전국 갭투자 조건 검색에서 선택한 가격·전세 조건에 해당하는 단지를 확인합니다.' },
    2: { title: '전세·생활권', description: '매매·전세 지표, 생활권 입주예정물량, 국민연금 가입자 현황을 차례로 확인합니다.' },
    3: { title: '단지·매물 비교', description: '단지·면적별 매매·전세 지표와 주간 매물지수를 비교합니다.' },
    4: { title: '입주·미분양', description: '입주 시점별 물량과 공사 완료 전·후 미분양의 변화를 확인합니다.' },
    5: { title: '지역 지표 비교', description: '시도·시군구 체크리스트의 지표를 각 단위와 기준일에 맞춰 비교합니다.' }
  },
  'find-region': {
    1: { title: '지역 지표', description: '시군구 종합 지표와 투자체크리스트를 같은 지역 기준으로 확인합니다.' },
    2: { title: '생활권 공급', description: '생활권 반경별 입주예정물량과 미분양 현황을 비교합니다.' },
    3: { title: '인구·일자리', description: '시도·시군구 간 전입·전출 규모와 국민연금 가입자 현황을 확인합니다.' },
    4: { title: '가격·매물 흐름', description: '시군구별 매매·전세 흐름과 단지별 주간 매물지수의 변화를 비교합니다.' },
    5: { title: '후보 단지 비교', description: '매매가격 구간으로 단지를 찾고, 단지·면적별 매매·전세 지표를 비교합니다.' }
  },
  'new-home': {
    1: { title: '주변 가격대', description: '분양 지역 주변의 기존 단지를 매매가격 범위로 찾아봅니다.' },
    2: { title: '기존 단지 비교', description: '주변 단지의 실거래가격과 매매·전세 지표를 같은 면적 기준으로 비교합니다.' },
    3: { title: '입주·정비사업', description: '생활권 내 입주예정물량과 주변 정비사업 현황을 확인합니다.' },
    4: { title: '전세·매물 현황', description: '주변 단지의 매매·전세 가격 지표와 주간 매물지수를 함께 확인합니다.' },
    5: { title: '정비사업 현황', description: '관심 지역에 어떤 정비사업이 있는지 원본 현황에서 확인합니다.' }
  },
  rebalance: {
    1: { title: '실거래·매물', description: '보유 단지의 실거래가격과 세대수 대비 주간 매물수 변화를 확인합니다.' },
    2: { title: '지역 흐름', description: '시군구 가격·거래 지표, 국민연금 가입자 현황, 입주물량을 함께 확인합니다.' },
    3: { title: '거래가격 비교', description: '같은 지역·단지의 실거래가격을 면적과 거래 시점별로 비교합니다.' },
    4: { title: '종합 지표 확인', description: '시군구 종합 분석과 체크리스트에서 같은 지역의 지표를 비교합니다.' },
    5: { title: '매물 변화', description: '관심 단지의 주간 매물지수를 같은 조회 기간으로 이어서 확인합니다.' }
  },
  retirement: {
    1: { title: '가격대 찾기', description: '매매가격 구간을 바꿔 가며 관심 지역의 단지 목록을 확인합니다.' },
    2: { title: '일자리·인구', description: '국민연금 가입자, 전입·전출, 단지별 주간 매물지수를 함께 확인합니다.' },
    3: { title: '실거래가격', description: '관심 지역·단지의 실거래가격을 면적과 거래 시점별로 확인합니다.' },
    4: { title: '입주·매물 흐름', description: '기간별 입주물량과 관심 단지의 주간 매물지수 변화를 비교합니다.' },
    5: { title: '단지 비교', description: '단지·면적별 매매와 전세 지표를 같은 기준으로 비교합니다.' }
  },
  advisor: {
    1: { title: '지역 요약', description: '한 시군구의 매매·전세, 거래, 입주물량 등 주요 지표를 함께 확인합니다.' },
    2: { title: '가격대 찾기', description: '관심 지역과 매매가격 범위에 해당하는 단지를 찾아봅니다.' },
    3: { title: '가격·매물 비교', description: '가격대별 단지 목록, 실거래가격, 주간 매물지수를 차례로 비교합니다.' },
    4: { title: '정비·전세 지표', description: '관심 지역의 정비사업 현황과 단지별 매매·전세 가격 지표를 확인합니다.' },
    5: { title: '단지 지표 비교', description: '단지·면적별 매매·전세 지표를 같은 기준으로 살펴봅니다.' }
  }
};
